import React, { useState, useEffect } from "react"
import { computeActivityFeed } from "../../../utils/activityFeedHelpers"
import ActivityDropdown from "../../../components/ui/activity-dropdown"

const POLL_INTERVAL_MS = 60000

const RecentActivitySection = ({ orgId }) => {
  const [activities, setActivities] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    let cancelled = false

    const load = async () => {
      const items = await computeActivityFeed(orgId)
      if (!cancelled) {
        setActivities(items)
        setLoading(false)
      }
    }

    load()
    const intervalId = setInterval(load, POLL_INTERVAL_MS)

    return () => {
      cancelled = true
      clearInterval(intervalId)
    }
  }, [orgId])

  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-foreground mb-3">Recent Activity</h3>
      <ActivityDropdown activities={activities} loading={loading} />
    </div>
  )
}

export default RecentActivitySection